import React from 'react';
import TextComponent from 'shared/components/TextComponent';

// import ico from 'images/products/wave_solder_pallets/through-hole-components.png'

const ThroughHoleQuantity = (props) => {
  const { name,
    label,
    inputId,
    parameters,
    onChangeParameter,
    required,
    tooltip,
    children,
  } = props;

  const onChange = e => onChangeParameter(name, e.target.value);
  const value = parameters[name];
  return (
    <div className="row g-0 mb-3">
      <div className="col-4 col-md-3 col-lg-4">
        <img src={Spree.image_assets.through_hole_components} alt="Through-Hol Quantities" className="img-fluid mb-3" />
      </div>
      <div className="col-8 col-md-4 col-lg-8 ps-3 ps-md-0 ps-lg-3">
        <TextComponent
          label={label}
          name={name}
          inputId={inputId}
          value={value || ''}
          required={required}
          onChange={onChange}
          tooltip={tooltip}
          min="1">
          {children}
        </TextComponent>
      </div>
    </div>
  );
};

ThroughHoleQuantity.defaultProps = {
  inputId: 'through_hole_component_pressed_quantity',
  label: 'How many through-hole components need to be pressed down with shoulder bolts? ($1 each)',
  name: 'through_hole_component_pressed_quantity',
  required: true,
};

export default ThroughHoleQuantity;
